import * as React from 'react';

import {
  Command,
  CommandEmpty,
  CommandInput,
  CommandList,
} from '../../lib/command.jsx';

type ComboboxMenuProps = Readonly<{
  children: React.ReactNode;
  withSearch?: boolean;
  emptyMessage?: React.ReactNode;
  onValueChange?: (value: string) => void;
  shouldFilter?: boolean;
  placeholder?: string;
}>;
function ComboboxMenu({
  children,
  withSearch = false,
  emptyMessage = 'No options.',
  placeholder = 'Search',
  onValueChange,
  shouldFilter,
}: ComboboxMenuProps) {
  return (
    <Command shouldFilter={shouldFilter}>
      {withSearch && (
        <CommandInput
          placeholder={placeholder}
          className="border-b"
          select
          onValueChange={onValueChange}
          data-dd-action-name={`"${placeholder}" input`}
        />
      )}
      <CommandList className="outline-none focus-visible:outline-none">
        <CommandEmpty>{emptyMessage}</CommandEmpty>
        {children}
      </CommandList>
    </Command>
  );
}

export default ComboboxMenu;
